/**
 * 생성기 입력창이 펼쳐진 동안 감싼 뒤 화면(사이드바·목록)의 스크롤·클릭·포커스를 막는 경계.
 * 생성기 상태 구독은 이 컴포넌트만 한다 — 입력창을 여닫을 때 다시 그려지는 건 이 div 하나이고, children 은
 * 부모가 만든 요소 그대로라 다시 렌더되지 않는다. 부모가 생성기 열림을 구독하면 이 이점이 사라진다.
 */
import { type ReactNode } from 'react';
import { type AiGenerateDockBackgroundLockOptions, useAiGenerateDockBackgroundLock } from '../hooks/useAiGenerateDockBackgroundLock';
export const AiGenerateDockBackgroundLock = ({
  children,
  ...options
}: AiGenerateDockBackgroundLockOptions & {
  children: ReactNode;
}) => {
  const lockProps = useAiGenerateDockBackgroundLock(options);
  return <div {...lockProps} className="contents" data-sentry-component="AiGenerateDockBackgroundLock" data-sentry-source-file="AiGenerateDockBackgroundLock.tsx">
      {children}
    </div>;
};